import { Text } from 'tamagui'

export function SectionTitle({ children }: { children: string }) {
  return (
    <Text
      tag="h2"
      color="$text-primary"
      fontSize={32}
      fontFamily="$mulishBold"
      fontWeight="700"
      marginBottom={32}
    >
      {children}
    </Text>
  )
}
